export type ScoreOption = {
  value: string;
  label: string;
  emoji: string;
};

export const SCORES: ScoreOption[] = [
  { value: 'masterpiece', label: 'Шедевр', emoji: '🔥' },
  { value: 'good', label: 'Советую', emoji: '👍' },
  { value: 'beer', label: 'Под пиво', emoji: '🍺' },
  { value: 'mediocre', label: 'Так себе', emoji: '😐' },
  { value: 'terrible', label: 'Ужасно', emoji: '👎' },
] as const;

export const SCORES_ALL: ScoreOption[] = [
  { value: 'empty', label: 'Нет оценки', emoji: '💀' },
  { value: 'all', label: 'Все', emoji: '🌭' },
] as const;

export type Score = (typeof SCORES)[number]['value'];

export type Game = {
  gameId: string;
  aggregatorType: 'steam' | 'igdb';
  name: string;
  image: string;
  thumbnail: string;
};

export type ReviewBase = {
  game: Game;
  slug: string;
  score: Score;
  genres?: number[];
  description: unknown;
  status: string;
  isArchived: boolean;
};

export type Review = ReviewBase & {
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ReviewResponse = {
  review: Review;
};

export type GetReviewsResponse = {
  items: Review[];
  pagination: {
    page: number;
    perPage: number;
    total: number;
    totalPages: number;
  };
};

export type GetReviewResponse = {
  review: Review;
};
